import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewSubject = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('school-management/subject/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const activeSubject = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('school-management/subject/active/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addSubject = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('school-management/subject/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editSubject = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('school-management/subject/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const deleteSubject = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('school-management/subject/delete/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const toggleSubject = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('school-management/subject/status/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getSubject = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('school-management/subject/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
